import { Box, darkColors, Image, lightColors, SimpleGrid, useColorMode, useColorModeValue as mode } from '@chaine/keychaine';
import * as React from 'react';
import { SectionDescription } from '.';
export const useInteractiveBackground = (props) => {
    const { hoverColor } = props;
    const { colorMode } = useColorMode();
    const defaultCardBackground = mode(lightColors.white, darkColors.gray['800']);
    const [transform, setTransform] = React.useState('scale(1)');
    const [backgroundColor, setBackgroundColor] = React.useState(defaultCardBackground);
    React.useEffect(() => {
        setBackgroundColor(defaultCardBackground);
    }, [colorMode, defaultCardBackground]);
    const handleMouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const xPercent = ((e.clientX - rect.left) / rect.width) * 100;
        const yPercent = ((e.clientY - rect.top) / rect.height) * 100;
        setTransform(`scale(1.03) translate(${(xPercent - 50) / 5}px, 0px)`);
        setBackgroundColor(`radial-gradient(circle at ${xPercent}% ${yPercent}%, ${hoverColor}, ${defaultCardBackground} 70%)`);
    };
    const handleMouseLeave = () => {
        setTransform('scale(1)');
        setBackgroundColor(defaultCardBackground);
    };
    return { transform, backgroundColor, handleMouseMove, handleMouseLeave };
};
export const LongSectionCallout = (props) => {
    const { component, highlightedText, hoverColor, link, text } = props;
    const { transform, backgroundColor, handleMouseMove, handleMouseLeave } = useInteractiveBackground({ hoverColor });
    const boxShadow = mode('xl', 'dark-lg');
    const padding = { base: 10, md: 12, lg: 14 };
    return (React.createElement(SimpleGrid, { columns: [1, 1, 2], h: { sm: 'xl', base: 'xl', md: 'xs', lg: 'md' }, bg: mode('white', 'gray.800'), overflow: "hidden", borderRadius: "xl", borderWidth: "1px", borderColor: "border.primary", boxShadow: boxShadow, onMouseMove: handleMouseMove, onMouseLeave: handleMouseLeave, style: {
            transform: transform,
            transition: 'transform 0.2s',
            background: backgroundColor
        } },
        React.createElement(Box, { padding: padding },
            React.createElement(SectionDescription, { highlightedText: highlightedText, link: link, text: text })),
        React.createElement(Box, { h: { base: 'xl', md: 'inherit', lg: 'inherit' }, display: "flex", alignItems: "center", alignContent: "center", justifyItems: "center" }, component)));
};
export const LeftRightSectionCallout = (props) => {
    const { component, highlightedText, hoverColor, link, text } = props;
    const { transform, backgroundColor, handleMouseMove, handleMouseLeave } = useInteractiveBackground({ hoverColor });
    const boxShadow = mode('2xl', 'dark-lg');
    const padding = { base: 10, md: 12, lg: 14 };
    return (React.createElement(SimpleGrid, { columns: 1, h: { sm: 'xl', base: 'xl', md: 'xl', lg: '2xl' }, bg: mode('white', 'gray.800'), overflow: "hidden", borderRadius: "xl", borderWidth: "1px", borderColor: "border.primary", boxShadow: boxShadow, onMouseMove: handleMouseMove, onMouseLeave: handleMouseLeave, style: {
            transform: transform,
            transition: 'transform 0.2s',
            background: backgroundColor
        } },
        React.createElement(Box, { padding: padding },
            React.createElement(SectionDescription, { highlightedText: highlightedText, link: link, text: text })),
        React.createElement(Box, { display: "flex", alignItems: "center", alignContent: "center", justifyItems: "center", h: "xl" }, component)));
};
export const ImageBox = (props) => {
    const { darkModeSRC, imageHeight, leftMargin, lightModeSRC, responsivePadding, topMargin } = props;
    return (React.createElement(Box, { height: "xl", width: "100%" },
        React.createElement(Image, { p: responsivePadding, mt: topMargin, ml: leftMargin, objectFit: "cover", src: mode(lightModeSRC, darkModeSRC), height: imageHeight })));
};
